import { Box, Grid } from '@mui/material';
import dynamic from 'next/dynamic';
import React from 'react';

import CategoriesLoading from 'components/common/Category/Skeleton';
import StoreCTX from 'provider/Store';
import WalletLoading from 'screen/Stores/Skeleton/WalletLoading';
import WidgetsLoading from 'screen/Stores/Skeleton/WidgetsLoading';
import { booleanParser } from 'utility/booleanParser';

const Widgets = dynamic(() => import('./Widgets'), { suspense: true });
const Wallet = dynamic(() => import('screen/Stores/Components/Wallet'), { suspense: true });
const Categories = dynamic(() => import('components/common/Category'), { suspense: true });

const Content = () => {
	const { state } = React.useContext(StoreCTX);

	return (
		<Grid container>
			<Box mt={'2.4rem'} width="100%">
				<Grid item xs={12}>
					<React.Suspense fallback={<CategoriesLoading />}>
						<Categories />
					</React.Suspense>
				</Grid>
			</Box>
			{!booleanParser(state.app_keepa) && (
				<Box mt={'4rem'} width="100%">
					<Grid item xs={12}>
						<React.Suspense fallback={<WalletLoading />}>
							<Wallet />
						</React.Suspense>
					</Grid>
				</Box>
			)}
			<Box mt={booleanParser(state.app_keepa) ? '-2rem' : '5.7rem'} width="100%">
				<Grid item xs={12}>
					<React.Suspense fallback={<WidgetsLoading />}>
						<Widgets />
					</React.Suspense>
				</Grid>
			</Box>
		</Grid>
	);
};

export default Content;
